// extracted by mini-css-extract-plugin
export default {"mainContainer":"Email_mainContainer__W4ZA2","formbox":"Email_formbox__Ry+Mo","btn":"Email_btn__2d3C2","btnDisabled":"Email_btnDisabled__BQn8m"};